import { useList } from "@refinedev/core";
import { DatasourceError } from "@shared/interfaces/schema-data";

interface UseDatasourceErrorsProps {
  eventId?: string | number;
  limit?: number;
  enableLive?: boolean;
}

/**
 * A convenience hook for fetching datasource errors with live updates.
 * This is just a thin wrapper around useList with sensible defaults.
 */
export const useDatasourceErrors = ({
  eventId,
  limit = 50,
  enableLive = true,
}: UseDatasourceErrorsProps = {}) => {
  const { data, isLoading, error, refetch } = useList<DatasourceError>({
    resource: "datasourceErrors",
    liveMode: enableLive ? "auto" : "off",
    meta: {
      fields: [
        "id",
        "publicId",
        "errorTitle",
        "errorDescription",
        "athleteId",
        "athleteForename",
        "athleteSurname",
        "athleteName",
        "athleteNameShort",
        "datasetDatasourceId",
        "clientId",
        "createdAt",
        "updatedAt",
      ],
    },
    pagination: {
      pageSize: limit,
    },
    filters: eventId
      ? [
          {
            field: "datasetDatasourceId",
            operator: "eq",
            value: eventId,
          },
        ]
      : undefined,
  });

  return {
    errors: data?.data || [],
    isLoading,
    error,
    refetch,
    total: data?.total || 0,
  };
};
